import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import BasicContentBox from '@root/components/v2/content/BasicContentBox';
import PageContainer from '@root/components/v2/layout/PageContainer';
import PageContent from '@root/components/v2/layout/PageContent';
import PageHeader from '@root/components/v2/layout/PageHeader';
import Breadcrumbs from '@root/components/v2/global/breadcrumbs';

const BREADCRUMBS = [{ title: 'Code Security' }, { title: 'Repository Scanning' }];

// Skeleton for individual chart cards
const ChartCardSkeleton = ({ height = '134px', title }) => (
  <BasicContentBox title={title} style={{ height }}>
    <div style={{ padding: '16px', height: 'calc(100% - 40px)' }}>
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </div>
  </BasicContentBox>
);

// Skeleton for table area
const TableSkeleton = () => (
  <div style={{ marginTop: '16px' }}>
    {/* Header bar skeleton */}
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
      <div style={{ display: 'flex', gap: '16px' }}>
        <Skeleton variant="rounded" width={120} height={36} />
        <Skeleton variant="rounded" width={100} height={36} />
      </div>
      <div style={{ display: 'flex', gap: '12px' }}>
        <Skeleton variant="rounded" width={300} height={36} />
        <Skeleton variant="rounded" width={100} height={36} />
      </div>
    </div>
    {/* Table skeleton */}
    <Skeleton variant="rectangular" width="100%" height={400} />
  </div>
);

const CodeRepoSkeleton = () => {
  return (
    <PageContainer>
      <PageHeader title={<Breadcrumbs breadcrumbs={BREADCRUMBS} />}>
        <Skeleton variant="text" width={150} height={24} />
      </PageHeader>
      <PageContent>
        <div className="CodeRepo__CommomCSSWrapper">
          <div className="CodeRepo_overview">
            {/* First row - Risk Level and Category */}
            <Grid container direction="row" spacing={1.7}>
              <Grid item xs={5}>
                <ChartCardSkeleton title="Alerts By RiskLevel" height="134px" />
              </Grid>
              <Grid item xs={7}>
                <ChartCardSkeleton title="Alerts By Category" height="134px" />
              </Grid>
            </Grid>

            {/* Second row - Alerts Over Time and Top Violated */}
            <Grid container direction="row" spacing={1.7}>
              <Grid item xs={6}>
                <ChartCardSkeleton title="Alerts Over Time" height="295px" />
              </Grid>
              <Grid item xs={6}>
                <ChartCardSkeleton title="Top Violated Controls" height="295px" />
              </Grid>
            </Grid>

            {/* Third row */}
            <Grid container direction="row" spacing={1.7}>
              <Grid item xs={6}>
                <ChartCardSkeleton title="Top Repositories With Most Issues" height="295px" />
              </Grid>
              <Grid item xs={6}>
                <ChartCardSkeleton title="Compliance Overview Score" height="295px" />
              </Grid>
            </Grid>

            {/* Fourth row */}
            <Grid container direction="row" spacing={1.7}>
              <Grid item xs={6}>
                <ChartCardSkeleton title="Code Issues" height="295px" />
              </Grid>
              <Grid item xs={6}>
                <ChartCardSkeleton title="Repositories With Malware" height="295px" />
              </Grid>
            </Grid>

            {/* Table area */}
            <TableSkeleton />
          </div>
        </div>
      </PageContent>
    </PageContainer>
  );
};

export default CodeRepoSkeleton;
